import {
  postTeacherLesson,
  getLessonsById,
  getTeacherLesson,
  postConclusion,
  createAudioText,
  createLessonGrammarIntro,
  newSpeaking,
  postPractices,
  getPractice,
  postGrammars,
  getGrammar,
} from "@/api/api";

export const namespaced = true;

export const state = {
  teacher: null,
  student: null,
  lesson: null,
  teacher_lesson: null,
  practice: null,
  grammar: null,
};
export const mutations = {
  teacher: (state, payload) => {
    state.teacher = payload;
  },
  student: (state, payload) => {
    state.student = payload;
  },
  lesson: (state, payload) => {
    state.lesson = payload;
  },
  teacher_lesson: (state, payload) => {
    state.teacher_lesson = payload;
  },
  practice: (state, payload) => {
    state.practice = payload;
  },
  grammar: (state, payload) => {
    state.grammar = payload;
  },
};
export const getters = {
  teacher: (state) => state.teacher,
  student: (state) => state.student,
  lesson: (state) => state.lesson,
  teacher_lesson: (state) => state.teacher_lesson,
  practice: (state) => state.practice,
  grammar: (state) => state.grammar,
};

export const actions = {
  lesson: async (context, payload) => {
    let response = await getLessonsById(payload.uuid);
    const lesson = response.data;
    context.commit("lesson", lesson);

    let teacher_lesson = lesson.teacher_lesson;
    if (!teacher_lesson) {
      response = await postTeacherLesson(lesson.uuid);
      teacher_lesson = response.data.uuid;
      await createAudioText(teacher_lesson, "teach");
      await createLessonGrammarIntro(teacher_lesson);
      await newSpeaking(teacher_lesson, "teach");
      postConclusion(teacher_lesson, "teach");
    }
    response = await getTeacherLesson(teacher_lesson);
    context.commit("teacher_lesson", response.data);

    let practice = lesson.practice;
    if (!practice) {
      response = await postPractices(lesson.uuid);
      practice = response.data.uuid;
      await createAudioText(practice, "practice");
      await newSpeaking(practice, "practice");
      postConclusion(practice, "practice");
      practice = response.data.uuid;
    }
    response = await getPractice(practice);
    context.commit("practice", response.data);

    let grammar = lesson.grammar;
    if (!grammar) {
      response = await postGrammars(lesson.uuid);
      grammar = response.data.uuid;
    }
    response = await getGrammar(grammar);
    context.commit("grammar", response.data);
  },
};
